import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppConfig } from 'src/app/config/app.config';
import { Error404Component } from 'src/app/core/error-404/error-404.component';
import { Error500Component } from 'src/app/core/error-500/error-500.component';
import { HomeComponent } from 'src/app/home/home.component';
import { ContactComponent } from './contact/contact.component';

const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '', component: HomeComponent, data: { title: 'Home' } },
  { path: AppConfig.routes.home, component: HomeComponent, data: { title: 'Home' } },
  { path: AppConfig.routes.about, component: HomeComponent, data: { title: 'Home' } },
  { path: AppConfig.routes.ranseps, loadChildren: './genomes/genomes.module#GenomesModule' },
  { path: AppConfig.routes.contact, component: ContactComponent, data: { title: 'Contact info' } },
  { path: AppConfig.routes.error404, component: Error404Component, data: { title: 'Request page not found 404' } },
  { path: AppConfig.routes.error500, component: Error500Component, data: { title: 'Internal Server error 500' } },

  // otherwise redirect to 404
  { path: '**', redirectTo: '/' + AppConfig.routes.error404 }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
